import './DropdownFilterWrapper.css';
import React, { useRef } from 'react';
import { ReactComponent as IconChevronDown } from '../../resources/icons/IconChevronDown.svg';
export const DropdownFilterWrapper = _ref => {
  let {
    children,
    defaultLabel,
    label,
    resultsLabel,
    showLabel,
    applyFn,
    open,
    setStartPage,
    primaryColor
  } = _ref;
  const [isOpen, setisOpen] = open;
  const rootRef = useRef();
  const borderRadius = {
    borderRadius: '4px'
  };
  const selectedPrimaryColor = primaryColor ? primaryColor : 'var(--main-color)';
  const variables = {
    '--listing-dropdown-primary-color': selectedPrimaryColor
  };
  function handleClick(e) {
    if (e.target.closest('.filter__field') !== rootRef.current) {
      setisOpen(false);
    }
  }
  const closeDropdwn = () => {
    setisOpen(false);
    if (setStartPage) {
      setStartPage(false);
    }
    document.body.removeEventListener('click', closeDropdwn);
  };
  const toggleFilter = e => {
    if (e.target.closest(`.filter-panel__box`)) {
      setisOpen(!isOpen);
      if (setStartPage) {
        setStartPage(isOpen);
      }
      if (isOpen) {
        document.body.removeEventListener('click', handleClick);
      } else {
        document.body.addEventListener('click', handleClick);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles}`,
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field dropdown-filter-wrapper",
    ref: rootRef
  }, /*#__PURE__*/React.createElement("div", {
    onClick: toggleFilter,
    onKeyPress: event => {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        event.preventDefault();
        event.target.click();
      }
    },
    className: `filter-panel eloqua ${isOpen ? 'filter-panel--open' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, defaultLabel), /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    className: `filter-panel__box ${isOpen ? 'filter-panel__box--openedDrop' : ''}`,
    style: !isOpen ? borderRadius : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-panel__trigger js-filter-panel__trigger"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, label), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })), isOpen && /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__bottom"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary js-btn-close-panel",
    onClick: () => applyFn && applyFn(closeDropdwn)
  }, showLabel, " ", resultsLabel))))));
};
const commonStyles = "cmjos24";